import $ from 'jquery';

(function () {
    const prefix = 'data-catalogue-dropdown';
    const attrs = {};
    attrs.depth = `${prefix}-depth`;
    attrs.id = `${prefix}-id`;
    attrs.ref = `${prefix}-ref`;
    attrs.list = `${prefix}-list`;
    attrs.link = `${prefix}-link`;
    const states = {};
    states.hidden = 'hidden';
    states.visible = 'visible';
    const timeout = 100;

    const $links = $(`[${attrs.ref}]`);

    $links.hover(function () {
        const link = this;
        const $link = $(link)
        const $section = $link.parents(`[${attrs.depth}]`);
        const depth = $section.attr(attrs.depth);
        const sectionsAmount = $(`[${attrs.depth}]`).length;
        const ref = $link.attr(attrs.ref);

        for (let i = +depth + 1; i <= sectionsAmount; i++) {
            $(`[${attrs.depth}="${i}"]`).find(`[${attrs.id}]`).attr(attrs.list, states.hidden);
            $(`[${attrs.depth}="${i}"]`).find(`[${attrs.ref}]`).attr(attrs.link, states.hidden);

            if (i === sectionsAmount) {
                $section.find(`[${attrs.ref}]`).each(function () {
                    toggleLink(this, states.hidden);
                });
                if (ref !== 'false') {
                    changeListState(link, states.visible);
                    toggleLink(this, states.visible);
                }
            }
        }
    });

    function findList(link) {
        const $link = $(link);
        const ref = $link.attr(attrs.ref);
        const $list = $(`[${attrs.id}="${ref}"]`);

        return $list;
    }

    function changeListState(link, state) {
        const $list = findList(link);

        if ($list.length < 1) return false;
        $list.attr(attrs.list, states[state]);
    }

    function toggleLink(link, state) {
        const $link = $(link);
        $link.attr(attrs.link, states[state]);
    }
})();
